var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdd = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960",
  width: "1em",
  height: "1em",
  fill: "currentColor"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
})));
export default SvgAdd;